import Vue from 'vue'
import Footer from './Footer.vue'
import store from '@/store'
import config from '@/mixins/componentConfiguration'
import commonConfig from '@/mixins/commonMixin'

window.vm2 = new Vue({
  store,
  mixins: [commonConfig(Vue), config(Vue)],
  render: h => h(Footer)
}).$mount('#footer')
